<template>
  <div class="pb-8 md:pb-20">
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">our team</h1>
    <hr />
    <div class="text-center py-7" v-if="ready">
      <div class="ql-snow text-left mb-2 lg:mb-24">
        <div class="ql-editor">
          <div class="mb-4" v-html="textContent"></div>
        </div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4">
        <OurTeamEmployee
          :name="employee.name"
          :title="employee.team_member_category.name"
          :address="employee.city_state"
          :phone="employee.phone_number"
          :email="employee.email"
          :album="album"
          :image="employee.cached_image"
          :color="employee.team_member_category.color"
          v-for="employee in employees"
          :key="employee.id"
        />
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>

<script setup>
import { http } from "~/utils/http";
import {ref} from "vue";

const employees = ref(null);
const textContent = ref('');
const album = ref(null);
const ready = ref(false);

const getTeam = async () => {
  try {
    await http.get("/api/team-members").then((json) => {
      employees.value = json.data.employees;
      textContent.value = json.data.textContent.content;
      album.value = json.data.album;
      ready.value = true;
    });
  } catch (e) {}
};
getTeam();
</script>
